<template>
  <div>
    <list
      row-key="OtherReceivId"
      ref="list"
      unit="核销单"
      light-row
      @row-select="(x) => $emit('change', x)"
      :page="page"
      :queryParamsAppend="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      urlHash="finance/dealings/writeoff"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="核销类型" label-width="100px">
          <el-select v-model="params.CancelTypeId" @change="typeChange" placeholder="请选择">
            <el-option label="收款核销" :value="0"></el-option>
            <el-option label="付款核销" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据编号" label-width="100px">
          <el-input clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="单据日期" v-if="!isMB" label-width="100px">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <!-- <el-form-item label="冲销单据日期" v-if="!isMB" label-width="100px">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item> -->
        <el-form-item label="往来单位" label-width="100px">
          <select-input
            placeholder="请选择单位"
            :label="params.TradeUnitName"
            v-model="params.TradeUnitId"
            @click="openTradeunit"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>

    <tradeunit-dialog ref="tradeunitDialog" selectable @select="setTradeunit" />
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/finance/dealings/writeoff/list.json";
import tableParam from "@/data/finance/dealings/writeoff/query.json";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    tradeunitDialog,
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/rp/rpWoDoc").default,

      params: {
        CancelTypeId: 0, //收款核销/付款核销
        TradeUnitId: null,
        // BusinessTypeId: null,
        DocNo: null,
        DocDateStart:'', //单据日期
        DocDateEnd: '', //单据日期
      },
      isMB: this.$store.state.isMB,
    };
  },

  mounted() {
    if (!this.$permission.canPrice("/finance/dealings/writeoff")) {
      const findIndex = this.$refs.list.tableList.findIndex(item => item.tableName == "CurrentTotalAmount");
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1);
    }
  },
  methods: {
    typeChange(type) {
      this.$emit("type-change", type);
      this.query();
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.FullName;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.$emit("reload");
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>
